import PropTypes from 'prop-types';
import { DateMode } from './dateSelect.types';
export const DateSelectDefaultProps = {
    mode: DateMode.DATE_LIMIT,
    minimumAge: 18,
    maximumAge: 70,
    minimumYear: 1950,
    disabled: false,
    isInvalid: false,
    reverseDate: false,
    id: ''
};
export const DateSelectPropTypes = {
    /** Mode to get year values, type of DateMode */
    mode: PropTypes.oneOf([DateMode.DATE_LIMIT, DateMode.AGE_LIMIT]),
    /** Maximum age, on mode AGE_LIMIT */
    maximumAge: PropTypes.number,
    /** Minimum age, on mode AGE_LIMIT */
    minimumAge: PropTypes.number,
    /** Maximum year, on mode DATE_LIMIT */
    maximumYear: PropTypes.number,
    /** Minimum year, on mode DATE_LIMIT */
    minimumYear: PropTypes.number,
    /** Callback that return select value in format DD/MM/YYYY */
    onChange: PropTypes.func,
    /** Disable Selec inputs */
    disabled: PropTypes.bool,
    /* Error state */
    isInvalid: PropTypes.bool,
    title: PropTypes.string,
    yearLabel: PropTypes.string,
    monthLabel: PropTypes.string,
    dayLabel: PropTypes.string,
    months: PropTypes.object,
    reverseDate: PropTypes.bool,
    id: PropTypes.string,
};
//# sourceMappingURL=dateSelect.prop-types.js.map